import styled from '../../Styles/themed-styled-components';

import { LogoBl } from '../../Assets/LogoBl';

export const LogoFooter = styled(LogoBl)`
  height: 15px;
  width: auto;
  fill: ${(props) => props.theme.colors.grey[50]};
`;
